import { Controller } from "@hotwired/stimulus";

// « Imprimer » the last receipt of a year's block (owner's request of
// 29/10/2026), as « Encaisser et imprimer » does: the PDF loaded out of
// sight in a frame, its print window opened once it is there.
//
// Usage: <button data-controller="receipt-print" data-receipt-print-url-value="/…/receipts/1.pdf"
//                data-action="receipt-print#print">
export default class extends Controller {
  static values = { url: String };

  disconnect() {
    this.frame?.remove();
  }

  print() {
    this.frame?.remove();
    const frame = document.createElement("iframe");
    frame.setAttribute("aria-hidden", "true");
    frame.tabIndex = -1;
    frame.title = this.element.textContent.trim();
    frame.style.cssText = "position:fixed; right:0; bottom:0; width:1px; height:1px; border:0; opacity:0;";
    frame.addEventListener("load", () => {
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (_error) {
        // A browser that will not print a PDF in a frame opens it instead.
        window.open(this.urlValue, "_blank", "noopener");
      }
    });
    frame.src = this.urlValue;
    document.body.appendChild(frame);
    this.frame = frame;
  }
}
